import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "احسب نسبة 20% من مبلغ - حاسبة 20 بالمئة الالكترونية - تعلم كم تساوي عشرون في المئة";
const DESCRIPTION =
  "تعلم كيف تقوم ب احسب نسبة 20% من مبلغ - حاسبة 20 بالمئة - حساب كم تساوي عشرون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 20 بالمئة من مبلغ او قيمة معينة";
const KEYWORDS =
  "احسب نسبة 20% من مبلغ - حاسبة 20 بالمئة - حساب كم تساوي عشرون بالمئة, 20%, حساب النسبة المئوية";
const OG_URL = "https://do-calculate.com/calculator/ar/20percent";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  لحساب نسبة 20% من قيمة معينة، يمكنك اتباع الخطوات التالية:
                </h2>
                <ul>
                  <li>
                    قم بضرب القيمة بنسبة 20% ككسر. يمكن تمثيل 20% على شكل كسر
                    على النحو التالي: 20/100.
                  </li>
                  <li>
                    بعد ذلك، قم بضرب القيمة الأصلية في النسبة المكونة من الكسر.
                    لنفترض أن لديك قيمة معينة تريد حساب 20% منها، فلنقل أن هذه
                    القيمة تساوي 100، يمكنك استخدام المعادلة التالية:
                    <br />
                    النسبة = (القيمة الأصلية × الكسر 20/100)
                  </li>
                  <li>
                    أو يمكنك ببساطة إجراء العملية الحسابية كالتالي: قسم القيمة
                    الأصلية على 20.
                    <br />
                    النسبة = القيمة الأصلية / 20
                  </li>
                  <li>ستحصل على النسبة المطلوبة، وهي 20% من القيمة الأصلية.</li>
                </ul>
                <b>
                  يمكنك أيضا استخدام الحاسبة الالكترونية التالية لحساب نسبة 20
                  بالمئة من رقم او مبلغ معين:
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={20} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default Calculator;
